<section class="">
  <!-- Tabs section associated with preview -->
  <div id="newSegments" class="preview_control">
    <div id="newSegmentTabs-content" class="tab-content newSegmentTabs-content">
      <div id="newSegmentsTab" class="tab-pane fade show active" id="segmentAddContent" role="tabpanel">
        <div id="newSegmentsPages" class="pages_default_tab">
          <form [formGroup]="segmentsForm">
            <div id="newSegmentsRow" class="row">
              <div id="newSegmentsCol" class="col-md-6">
                <div id="newSegmentsFormGrp" class="form-group">
                  <label for="headline"><span i18n="@@create-segments.form-group.headline">Headline</span><span
                      class="text-danger">*</span></label><span class="formfield_limit_msg"
                    i18n="@@create-segments.tab-section.max-50-characters">(Max 50 characters)</span>
                  <input type="text" class="form-control" id="headline" formControlName="headline" name="headline"
                    required placeholder={{enterHeadlinePlaceholder}} maxlength="50" />
                  <div id="newSegmentsSubmittedName" *ngIf="isSubmitted && segmentsForm?.controls?.headline?.value.trim() === ''"
                    class="formfield_err_msg"> <span i18n="@@create-segments.tab-section.required-field">This is a
                      required field.</span></div>
                  <div id="newSegmentsSubmittedMax" *ngIf="isSubmitted && segmentsForm?.controls?.headline?.errors?.maxlength"
                    class="formfield_err_msg"><span i18n="@@create-segments.tab-section.50-characters-long">Headline may
                      be up to 50 characters long.</span></div>
                </div>
                <div id="createSegmentsFormGrp" class="form-group">
                  <label for="subHeadline"><span
                      i18n="@@create-segments.form-group.subheadline">Sub-headline</span></label><span
                    class="formfield_limit_msg" i18n="@@create-segments.tab-section.max-50-characters">(Max 50
                    characters)</span>
                  <input type="text" class="form-control" id="subHeadline" formControlName="subHeadline"
                    name="subHeadline" placeholder={{enterSubHeadlinePlaceholder}} maxlength="50" />
                  <div *ngIf="isSubmitted && segmentsForm?.controls?.subHeadline?.errors?.maxlength"
                    class="formfield_err_msg"><span
                      i18n="@@create-segments.tab-section.subheadline-50-characters">Sub-headline may be up to 50
                      characters long.</span></div>
                </div>
                <div id="retailerFormGrp" class="form-group">
                  <label for=""><span i18n="@@create-segments.form-group.retailer-name">Retailer
                      Name</span></label><span class="formfield_limit_msg" i18n="@@create-segments.tab-section.max-50-characters">(Max
                    50 characters)</span>
                  <input type="text" class="form-control" id="retailerName" formControlName="retailerName" name="retailerName"
                    placeholder={{enterRetailerNamePlaceholder}} maxlength="50" />
                  <div id="retailerSubmittedName" *ngIf="isSubmitted && segmentsForm?.controls?.retailerName?.errors?.maxlength" class="formfield_err_msg"><span
                      i18n="@@create-segments.form-group.retailer-50-characters">Retailer
                      Name may be up to 50 characters long.</span></div>
                </div>
              </div>
              <div id="segmentThemeCol" class="col-md-6 segment_color_column">
                <div id="segmentThemeFormGrp"  class="form-group">
                  <label for=""><span i18n="@@create-segments.form-group.segment-theme">Segment Theme</span></label>
                  <div id="segmentThemeOpemModal" class="theme_picker_button default cursor-pointer" (click)="openColPicModal()">
                    <span class="text_color" [style.background-color]="segmentThemeForm.hcolor"></span>
                    <span class="bg_color" [style.background-color]="segmentThemeForm.bgcolor"></span>
                  </div>
                </div>
                <div id="SegmentColorRow" class="segment_color_row">
                  <div id="segmentFormGrp" class="form-group">
                    <label for=""><span i18n="@@create-segments.form-group.segment-color">Segment Color</span></label>
                    <div id="segmentColorPicker" class="color_picker_button cursor-pointer" [cpPosition]="'right'"
                      [(colorPicker)]="segmentThemeForm.bgcolor" (colorPickerChange)="updateBgColor($event)"
                      [style.background]="segmentThemeForm.bgcolor" name="bgcolor"></div>
                  </div>
                  <div id="segmentFontColor" class="form-group">
                    <label for="">
                      <span i18n="@@create-segments.form-group.segment-font-color">Segment Font Color</span>
                      <a class="info_icon gtmAssetLibraryCreateSegmentSegmentFontColor" tabindex="0"
                        ngbPopover={{colorInfoTooltip}}
                        triggers="mouseenter:mouseleave"
                        [placement]="changePlacement == true ? 'right' : 'left'">
                        <img src="" class="upload_req_img" alt="upload requirements" />
                      </a>
                    </label>
                    <div id="segmentUpdateFontColor" class="color_picker_button cursor-pointer" [cpPosition]="changePlacement == true ? 'right' : 'left'"
                      [(colorPicker)]="segmentThemeForm.hcolor" (colorPickerChange)="updateFontColor($event)"
                      [style.background]="segmentThemeForm.hcolor" name="hcolor"></div>
                  </div>
                </div>
                <div id="applyToIpos" class="form-check" *ngIf="!isBrandColorEnabled">
                  <input class="form-check-input" type="checkbox" value="" id="isApplyToIpos" name="isApplyToIpos"
                    (change)="applySegmentColorToIpos($event)" formControlName="isApplyToIpos" />
                  <label class="form-check-label" for="isApplyToIpos" style="color: #262626">
                    <span i18n="@@create-segments.form-group.apply-segment-color-to-ipos">Apply Segment Color to
                      IPOS</span>
                  </label>
                </div>
                <div id="brandColorEnabled" *ngIf="isBrandColorEnabled">
                  <span i18n="@@create-segments.form-group.ipos-background-color">IPOS Background Color</span>
                  <div class="mt-2 form-check">
                    <input class="form-check-input" type="radio" value="" id="brandColor" name="bg_color" [checked]="isBrandColorChecked" (click)="applyBackgroundColorToIpos(brandColor)"/>
                    <label class="form-check-label" for="brandColor" style="color: #262626">
                      <span i18n="@@create-segments.form-group.brand-color">Brand Color</span>
                    </label>
                  </div>
                  <div id="segmentColorBack" class="mt-2 form-check">
                    <input class="form-check-input" type="radio" value="" id="segmentColor" name="bg_color" [checked]="isSegmentColorChecked" (click)="applyBackgroundColorToIpos(segmentColor)"/>
                    <label class="form-check-label" for="segmentColor" style="color: #262626">
                      <span i18n="@@create-segments.form-group.segment-color">Segment Color</span>
                    </label>
                  </div>
                  <div id="noColor" class="mt-2 form-check">
                    <input class="form-check-input" type="radio" value="" id="noColor" name="bg_color" [checked]="isNoColorChecked" (click)="applyBackgroundColorToIpos(noneColor)"/>
                    <label class="form-check-label" for="noColor" style="color: #262626">
                      <span i18n="@@create-segments.form-group.none">None</span>
                    </label>
                  </div>
                </div>
              </div>

            </div>
            <div id="applyContentGrpRow" class="row">
              <div id="applyContentGrpCol"  class="col-md-12">
                <div id="applyContentGrpsubCol" class="col-md-6 apply-content-grp-div">
                  <div id="segmentDateRow" class="segment_date_row">
                    <div id="segmentFormGrp" class="form-group">
                      <label for=""><span i18n="@@create-segments.form-group.apply-content-group-to">Apply content group
                          to</span></label>
                      <button type="button" class="btn btn-primary btn-sm left_icon_btn gtmFormFactorSeg"
                        (click)="openFormFactorsModal()">
                        <img src="assets/images/laptop_icon.svg" alt="select form factors" />
                        <span i18n="@@create-segments.form-group.select-form-factors">Select Form Factors</span>
                      </button>
                      <iposcen-form-factors #formFactorsModal [contentName]="selectedFormFactors"
                        (applyFormFactor)="applyFormFactor($event)"></iposcen-form-factors>
                      <div id="selectedFormFactors" *ngIf="selectedFormFactors" class="selected_factors">
                        <div  id="applyFormFactorDevicesSection">
                          <div id="applyFormFactorDeviceTypes" class="font-bold inline-block"><span>{{deviceTypes}}</span>:</div>
                          <div id="selectedFormFactorsdevices" class="inline">&nbsp;<span>{{ selectedFormFactors?.devices}} </span></div>
                        </div>
                        <div id="applyFormFactorManufacturesSection">
                          <div  id="applyFormFactorManufactures" class="font-bold inline-block"><span>{{manufacturers}}</span>:</div>
                          <div id="selectedFormFactorsManufactures" class="inline">&nbsp;<span>{{selectedFormFactors?.manufacturer}}</span></div>
                        </div>
                        <div id="applyFormFactorProcessorsSection">
                          <div id="applyFormFactorProcessors" class="font-bold inline-block"><span>{{processors}}</span>:</div>
                          <div id="selectedFormFactorsProcessors" class="inline">&nbsp;<span>{{ selectedFormFactors?.processors}}</span></div>
                        </div>
                        <div  id="applyFormFactorGenerationSection">
                          <div id="applyFormFactorGeneration" class="font-bold inline-block"><span>{{generation}}</span>:</div>
                          <div  id="selectedFormFactorsGeneration" class="inline">&nbsp;<span>{{ selectedFormFactors?.generations}}</span></div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div id="publishedTimeStampRow" class="row">
              <div  id="publishedTimeStampCol" class="col-md-12">
                <label for="publishedTimeStamp"><span i18n="@@create-segments.form-group.publish-date-time">Publishing Date
                    and Time</span></label>
                <div id="publishDateSection"  class="publishDate-Section">
                  <div id="publishDateRadio" class="custom-radio">
                    <input type="radio" name="publishdate" id="now" class="form-check-input" id="now"
                      [checked]="!isPublishDateCustomDatepicker" (click)="selectCustomPublishDate('Now')" />
                    <label for="now"><span i18n="@@create-segments.form-group.now">Now</span></label>
                  </div>
                  <div id="publishDateCustomDatepicker" class="custom-datepicker">
                    <input type="radio" name="publishdate" id="publish-date-custom" class="form-check-input"
                      id="publish-date-custom" [checked]="isPublishDateCustomDatepicker"
                      (click)="selectCustomPublishDate('custom')" />
                    <label for="publish-date-custom" *ngIf="!isPublishDateCustomDatepicker"><span
                        i18n="@@create-segments.form-group.custom">Custom</span></label>
                    <div id="PublishDateCustomDatepickerTimeZone" *ngIf="isPublishDateCustomDatepicker">
                      <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'publish')"
                        (getDateTimeZoneData)="getLogoContentPublishDate($event)" (isTimeZoneSelected)="checkTimeZone($event,'publish')"
                        [publishDateInfo]="editPublishDateInfo">
                      </iposcen-date-time-zone>
                    </div>
                  </div>
                </div>
                <div id="CustomPublishDateCorrect" *ngIf="isCustomPublishDateCorrect || isCustomPublishTimeZoneSelected" class="formfield_err_msg"><span
                    i18n="@@create-segments.form-group.publish-date-time-zone">Please select publishing date and time
                    zone.</span>
                </div>
              </div>
            </div>
            <div  id="expiryTimeStampRow" class="row">
              <div id="expiryTimeStampCol" class="col-md-12 expiry-div">
                <label for="publishedTimeStamp"><span i18n="@@create-segments.form-group.expiry-date-time">Expiration
                    Date and Time</span></label>
                <div id="expiryDateSection" class="publishDate-Section">
                  <div id="expiryDateRadio" class="custom-radio">
                    <input type="radio" name="expiryDate" id="never" class="form-check-input" id="never"
                      [checked]="!isExpiryDatePicker" (click)="selectExpiryDateTimeZone('Never')" />
                    <label for="never"><span i18n="@@create-segments.form-group.never">Never</span></label>
                  </div>
                  <div id="expiryCustomeDatePicker" class="custom-datepicker">
                    <input type="radio" name="expiryDate" id="expiry-custom" class="form-check-input" id="expiry-custom"
                      [checked]="isExpiryDatePicker" (click)="selectExpiryDateTimeZone('custom')" />
                    <label for="expiry-custom" *ngIf="!isExpiryDatePicker"><span
                        i18n="@@create-segments.form-group.custom">Custom</span></label>
                    <div  id="expiryDatePickerTimeZone" *ngIf="isExpiryDatePicker">
                      <iposcen-date-time-zone (errorMessageTime)="checkIfTimeset($event,'expiry')"
                        (getDateTimeZoneData)="getLogoContentExpiryDate($event)" (isTimeZoneSelected)="checkTimeZone($event,'expiry')"
                        [expiryDateInfo]="editexpiryDateInfo">
                      </iposcen-date-time-zone>
                    </div>
                  </div>
                </div>
              </div>
              <div id="expiredDateIncorrect" *ngIf="isExpiredDateIncorrect" class="formfield_err_msg errMsg"><span
                  i18n="@@create-segments.form-group.less-than-publish-date">Expiration date should not be before publishing date.</span>
              </div>
              <div  id="customExpiryDateCorrect" *ngIf="isCustomExpiryDateCorrect || isCustomExpiryTimeZoneSelected" class="formfield_err_msg errMsg"><span
                  i18n="@@create-segments.form-group.expiry-date-time-zone">Please select expiration date and time
                  zone.</span>
              </div>
            </div>
            <div id="btnWrapper" class="button-wrapper" style="justify-content: flex-end">
              <button type="button" (click)="cancel()" class="btn btn-outline-primary gtmCancelSeg">
                <span i18n="@@create-segments.form-group.cancel">Cancel</span>
              </button>
              <button type="button" class="btn btn-primary gtmSaveSeg" (click)="onAdd()"
                [disabled]="segmentsForm?.controls?.headline?.value?.trim() === ''">
                <span class="gtmSaveSeg" i18n="@@create-segments.form-group.save-proceed">Save and Proceed</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</section>
<ng-template #colorpicker>
  <div id="colorPickerCard" class="card">
    <div id="colorPickerModal" class="modal-header p-0">
      <div id="colorPickerClose" (click)="dismiss()" class="close_icon popup_close cursor-pointer">
        <img src="assets/images/popup_close_button.svg" alt="close icon" />
      </div>
    </div>
    <div id="colorPickerModalBody"class="modal-body p-0">
      <div id="themePick" class="card">
        <div id="themePickHeader" class="theme_pick_header" [style.background-color]="segmentThemeForm.bgcolor">
          <div id="themePickTitle" class="theme_pick_title" [style.color]="segmentThemeForm.hcolor">
            <span i18n="@@create-segments.form-group.segment-heading">Segment Headline</span>
          </div>
        </div>
        <div id="themeColor" class="theme_color mb-3">
          <div id="themeWrapper" class="theme-wrapper">
            <div id="themePickerBtn" class="theme_picker_button default" (click)="chooseTheme('#ffffff','#0068B5')">
              <span class="text_color text_color_white"></span>
              <span class="bg_color bg_color_blue_shade"></span>
            </div>
            <span [ngClass]="{'color_highlighter': isSelected('#ffffff','#0068B5' )}"></span>
          </div>
          <div id="themeColorRed" class="theme-wrapper">
            <div id="themeColorRedBtn" class="theme_picker_button default" (click)="chooseTheme('#ffffff','#C81326')">
              <span class="text_color text_color_white"></span>
              <span class="bg_color bg_color_red"></span>
            </div>
            <span [ngClass]="{'color_highlighter': isSelected('#ffffff','#C81326')}"></span>
          </div>
          <div id="themeColorMaroon"class="theme-wrapper">
            <div id="themeColorMarronBtn"class="theme_picker_button default" (click)="chooseTheme('#ffffff','#653171')">
              <span class="text_color text_color_white"></span>
              <span class="bg_color bg_color_maroon"></span>
            </div>
            <span [ngClass]="{'color_highlighter': isSelected('#ffffff','#653171')}"></span>
          </div>
          <div id="themeColorBlue" class="theme-wrapper">
            <div id="themeColorBlueBtn" class="theme_picker_button default" (click)="chooseTheme('#F6CB4B','#1E2EB8')">
              <span class=" text_color text_color_yellow"></span>
              <span class="bg_color bg_color_blue_shadee"></span>
            </div>
            <span [ngClass]="{'color_highlighter': isSelected('#F6CB4B','#1E2EB8')}"></span>
          </div>
          <div id="themeColorGrey" class="theme-wrapper">
            <div id="themeColorGreyBtn" class="theme_picker_button default" (click)="chooseTheme('#000964','#AEAEAE')">
              <span class="text_color text_color_dark_blue"></span>
              <span class="bg_color bg_color_grey"></span>
            </div>
            <span [ngClass]="{'color_highlighter': isSelected('#000964','#AEAEAE')}"></span>
          </div>
        </div>
        <div id="themeColorLightPurple" class="theme_color">
          <div id="themeColorLightPurpleWrapper"class="theme-wrapper">
            <div id="themeColorLightPurpleBtn" class="theme_picker_button default" (click)="chooseTheme('#262626','#98A1FF')">
              <span class="text_color text_color_black"></span>
              <span class="bg_color bg_color_light_purple"></span>
            </div>
            <span [ngClass]="{'color_highlighter': isSelected('#262626','#98A1FF')}"></span>
          </div>
          <div id="themeColorLightBlue" class="theme-wrapper">
            <div id="themeColorLightBlueBtn" class="theme_picker_button default" (click)="chooseTheme('#262626','#00C7FD')">
              <span class="text_color text_color_black"></span>
              <span class="bg_color bg_color_light_blue"></span>
            </div>
            <span [ngClass]="{'color_highlighter': isSelected('#262626','#00C7FD')}"></span>
          </div>
          <div id="themeColorBlack" class="theme-wrapper">
            <div id="themeColorBlackBtn" class="theme_picker_button default" style="margin-bottom:0" (click)="chooseTheme('#8BAE46','#262626')">
              <span class="text_color text_color_light_green"></span>
              <span class="bg_color bg_color_black"></span>
            </div>
            <span [ngClass]="{'color_highlighter': isSelected('#8BAE46','#262626')}"></span>
          </div>
        </div>
        <div id="segmentCardFooter" class="card-footer">
          <button type="button" class="btn btn-outline-primary" (click)="chooseTheme('#ffffff','#0068B5')">
            <span i18n="@@create-segments.form-group.use-default">Use Default</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</ng-template>